var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeeting(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#F5F8FA",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 19.4001H7.66667C7.0784 19.4001 6.6 18.9217 6.6 18.3334V8.73343C6.6 8.14516 7.0784 7.66676 7.66667 7.66676H9.8V7.13343C9.8 6.83903 10.0384 6.6001 10.3333 6.6001C10.6283 6.6001 10.8667 6.83903 10.8667 7.13343V7.66676H15.1333V7.13343C15.1333 6.83903 15.3717 6.6001 15.6667 6.6001C15.9616 6.6001 16.2 6.83903 16.2 7.13343V7.66676H18.3333C18.9211 7.66676 19.4 8.14516 19.4 8.73343V18.3334C19.4 18.9217 18.9211 19.4001 18.3333 19.4001ZM16.2 8.73343V9.26676C16.2 9.56116 15.9616 9.8001 15.6667 9.8001C15.3717 9.8001 15.1333 9.56116 15.1333 9.26676V8.73343H10.8667V9.26676C10.8667 9.56116 10.6283 9.8001 10.3333 9.8001C10.0384 9.8001 9.8 9.56116 9.8 9.26676V8.73343H7.66667V18.3334H18.3317L18.3333 8.73343H16.2ZM12.3963 16.1996C12.5472 16.1964 12.6901 16.1292 12.7883 16.0145L15.5381 12.8145C15.7296 12.591 15.704 12.254 15.4805 12.0625C15.2581 11.871 14.9216 11.8956 14.7285 12.119L12.3653 14.87L11.2549 13.6924C11.0523 13.478 10.7152 13.4684 10.5003 13.6705C10.2864 13.8726 10.2768 14.2102 10.4789 14.4241L11.9957 16.0326C12.0971 16.1398 12.2368 16.2001 12.384 16.2001C12.3883 16.2001 12.392 16.2001 12.3963 16.1996Z",
    fill: "#353F45"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "assets/media/Meeting.e26438ec.svg";
export { ForwardRef as ReactComponent };